/*
 * @Author: Hyman Choi
 * @Date: 2021-01-27 14:34:31
 * @LastEditTime: 2021-03-09 16:30:30
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \SIUI.Cloud.Medical.Web\src\api\ultrasonicGroupsPost.js
 */
import request from '@/utils/request'
import config from '@/utils/config'

/**
 * 获取单个超人圈组内帖子
 *
 * @param {*} params
 */
export function getAllForumsList(params) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminForums/ForumGroup/AllForumsList',
    method: 'get',
    params
  })
}

/**
 * 置顶/取消超人圈组内帖子
 *
 * @param {*} params
 */
export function setPostTop(params) {
  return request({
    url: config.API_ROOT + '/Api/V1/AdminForums/ForumGroup/Forum/SetTopOrCancel',
    method: 'post',
    params
  })
}
